import { memo, useEffect } from 'react';
import { Layer, Source, useMap } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { ROUTING_ARROW_LAYER_STYLE, ROUTING_EVENTS_LAYER_STYLE, ROUTING_LAYER_STYLE } from '../../../constants/map';
import {
  activeReportRouteState,
  reportHistoricInteractiveState,
  reportHistoricLngLatsState,
} from '../../../storage/reports';

function RouteLayer() {
  const { map } = useMap();
  const assetId = useRecoilValue(activeReportRouteState);
  const collection = useRecoilValue(reportHistoricInteractiveState(assetId || ''));
  const lngLats = useRecoilValue(reportHistoricLngLatsState(assetId || ''));
  const geojson: GeoJSON.Feature = {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'LineString',
      coordinates: lngLats,
    },
  };

  useEffect(() => {
    if (!map) return;
    const arrowUrl = '/img/icons/map/arrow.png';
    map.loadImage(`${arrowUrl}`, (error, image) => {
      if (error) {
        return;
      }
      if (image && !map.hasImage('arrow')) {
        map.addImage('arrow', image);
      }
    });
  }, [map]);

  if (!assetId) return null;

  return (
    <>
      <Source
        type="geojson"
        data={geojson}
        id="routing"
      >
        <Layer {...ROUTING_LAYER_STYLE} />
        <Layer {...ROUTING_ARROW_LAYER_STYLE} />
      </Source>
      <Source
        type="geojson"
        data={collection}
        id="route-events"
      >
        <Layer {...ROUTING_EVENTS_LAYER_STYLE} />
      </Source>
    </>
  );
}

export default memo(RouteLayer);
